import * as React from 'react'
import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'

type Props = {
  className?: string
}

export const CheckIcon: React.FC<Props> = (props) => {
  return <IcomoonIcon name="check" className={props.className} />
}
